import { forwardRef, ReactNode } from "react";
import styles from "./ListTitleResultCard.module.scss";
import ListResultCard from "../common/ListResultCard.tsx";
import TruncatedTitle from "../../../../common/features/asset/TruncatedTitle.tsx";
import NthEdition from "../../../../common/features/asset/NthEdition.tsx";
import clsx from "clsx";
import {
  CompositeAsset,
  StoreAsset,
} from "../../../../common/api/decimal/common-types/manageAssets.ts";
import DefaultCoverBadge from "../../../../common/features/asset/DefaultCoverBadge.tsx";

function ListTitleResultCard(
  {
    asset,
    lazyLoad,
    buttons,
    topRow,
    detailTags,
    children,
  }: {
    asset: CompositeAsset<"explore"> | StoreAsset;
    lazyLoad?: boolean;
    buttons: ReactNode;
    topRow?: ReactNode;
    detailTags?: ReactNode;
    children?: ReactNode;
  },
  ref: React.ForwardedRef<HTMLElement>
) {
  const manageAsset = asset.manageAsset;
  return (
    <>
      <ListResultCard
        ref={ref}
        asset={asset}
        lazyLoad={lazyLoad}
        containerClassName={styles.container}
        cardClassName={styles.card}
        imageChildren={
          <DefaultCoverBadge explore={asset.explore} store={asset.store} />
        }
        footerButtons={
          <div className={clsx(styles.buttons, styles.bottomButtons)}>
            {buttons}
          </div>
        }
      >
        {topRow}
        <div className={styles.innerContents}>
          <div className={styles.bookDetails}>
            <TruncatedTitle asset={manageAsset} className={styles.title} />
            <div className={styles.subtitle}>{manageAsset.subtitle}</div>
            <NthEdition asset={manageAsset} className={styles.edition} />
            <div className={styles.authorPublisher}>
              <div>{manageAsset.author}</div>
              <div>{manageAsset.publisher}</div>
            </div>
            {detailTags && <div>{detailTags}</div>}
          </div>
          <div className={clsx(styles.buttons, styles.sideButtons)}>
            {buttons}
          </div>
        </div>
        {children}
      </ListResultCard>
    </>
  );
}

const Card = forwardRef(ListTitleResultCard);

export default Card;
